import { request } from '@blade/common';
export const getRecord = (data) => request({
    url: '/api/portrait-management/api/v1/portrait/comparison/records',
    method: 'POST',
    data
});
export const updateComment = (data) => request({
    url: '/api/portrait-management/api/v1/portrait/comparison/record/update',
    method: 'POST',
    data
});
export const exportRecord = (data) => request({
    url: '/api/portrait-management/api/v1/portrait/comparison/records/export',
    method: 'POST',
    data
});
// 停车场列表
export const getParkingLotsOpt = () => request({
    url: '/api/map-management/api/v1/map/component/parking/list/lots',
    method: 'GET'
});
// 获取车辆记录
export const getCarData = (data) => request({
    url: '/api/portrait-management/api/v1/automobile/record',
    method: 'POST',
    data
});
// 导出车辆记录
export const exportCarRecord = (data) => request({
    url: '/api/portrait-management/api/v1/automobile/record/export',
    method: 'POST',
    data
});
